import React, { useState, useRef, useMemo } from 'react';
import { Form, Dropdown, Modal } from "react-bootstrap";
import FontAwesome from 'react-fontawesome';

import ConfirmModal from '../../../../components/ConfirmModal';
import { getPostedTime } from '../../../../utils';
import CustomCarousel from '../../CustomCarousel';
import ImageSelector from '../../ImageSelector';

const Reply = ({ reply, profile, onReplyDelete, onEditReply }) => {
    const { replyId, user, images, comment, likedUsers, repliedBy, creationDate, lastUpdate } = reply;
    let profileImage;
    if(user?.profilePicture === "https://ramcotubular.com/wp-content/uploads/default-avatar.jpg"||user?.profilePicture==="/images/default-avatar.svg"){
        profileImage = '/assets/media/profile/default-avatar.jpeg'
    }else{
        profileImage=user?.profilePicture
    }
    const [confirmShow, setConfirmShow] = useState(false);
    const [isLiked, setIsLiked] = useState((likedUsers.findIndex(uid => uid === profile.uid) >= 0) ? true : false);
    const [likedCount, setLikedCount] = useState(likedUsers.length);
    const [likeLoading, setLikeLoading] = useState(false);

    const imagesRef = useRef(images);
    imagesRef.current = images;
    const [isEdit, setIsEdit] = useState(false);
    const [editComment, setEditComment] = useState(comment);
    const [editImages, setEditImages] = useState(images);

    const [showSelectImageModal, setShowSelectImageModal] = useState(false);
    const showImageModal = () => setShowSelectImageModal(true);
    const hideImageModal = () => setShowSelectImageModal(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
        if (isDeleting) return null;
        setIsDeleting(true);
        try {
            await profile.deleteReply(replyId, reply.postId);
            onReplyDelete(replyId);
        } catch (error) {
            console.log(`Error in handleDelete ${error}`);
        } finally {
            setConfirmShow(false);      
            setIsDeleting(false);      
        }
    }

    const handleLiked = async () => {
        if (likeLoading) return;
        try {
            setLikeLoading(true);
            let res = false;
            if (isLiked) { // dislike 
                res = await profile.likeReply(reply.replyId, profile.uid, false);
                setLikedCount(likedCount - 1);
            }
            else { // like
                res = await profile.likeReply(reply.replyId, profile.uid, true);
                setLikedCount(likedCount + 1);
            }
            if (res)
                setIsLiked(!isLiked);
        } catch (error) {

        } finally {
            setLikeLoading(false);
        }
    }

    const handleEditReply = () => {
        setIsEdit(true);
    }

    const handleSaveEditedReply = async () => {
        try {
            const res = await profile.updateReply(replyId, editImages, editComment);
            if (res) {
                setIsEdit(false);
                onEditReply(replyId, editImages, editComment);
            }
        } catch (error) {
            console.log(`Error in handleSaveEditedReply ${error}`);            
        }     
    }

    const handleCancelReply = () => {
        setEditComment(comment);
        setEditImages([...images]);
        setIsEdit(false);
    }

    const handleSaveImages = (images) => {
        setEditImages(images);
    }

    const handleDeleteImages = () => {
        setEditImages([]);
    }

    const renderReplierActions = () => {
        if (repliedBy !== profile.uid) return (null);
        return (
            <div className="reply-action">
                <Dropdown>
                    <Dropdown.Toggle>
                        <FontAwesome name="ellipsis-h"/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleEditReply}>
                            <FontAwesome name="edit" style={{margin: "auto 10px auto 0"}}/>
                            Edit
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setConfirmShow(true)}>
                            <FontAwesome name="trash" style={{margin: "auto 10px auto 0"}}/>
                            Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }

    const renderImages = useMemo(() => {
        let imagestoRender = [];
        if (repliedBy === profile.uid) imagestoRender = editImages;
        else imagestoRender = imagesRef.current;
        if (!imagestoRender || !imagestoRender.length) return (null);
        return (
            <CustomCarousel
                cName="images-to-reply"
                images={imagestoRender}
                deselect={false}
            />
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imagesRef.current, editImages]);

    return (
        <div className="reply-data">
            <div className="replier-image">
                <img src={profileImage} alt=""/>
            </div>
            <div className="reply-content">
                <div className="reply-header">
                    <div>
                        <div className="repiler-name">
                            {user?.fullName}
                        </div>
                        <div className="repiler-role">
                            {user?.myRole}
                        </div>
                    </div>
                    <div className="creation-time">
                        {getPostedTime(creationDate)}
                        {creationDate.seconds !== lastUpdate.seconds ? ` - edited (${getPostedTime(lastUpdate)})`:""}
                    </div>
                    {renderReplierActions()}
                </div>
                <div style={{marginTop: "10px"}} >
                    {renderImages}
                </div>
                {isEdit?
                    <div style={{marginTop: "10px"}} >
                        <div className="edit-images">
                            <div className="add-image" onClick={showImageModal}>
                                <FontAwesome name='image'/>
                            </div>
                            {editImages.length ? <div className="add-image" onClick={handleDeleteImages}>
                                <FontAwesome name='trash'/>
                            </div>:(null)}
                        </div>
                        <Form.Control
                            value={editComment}
                            onChange={(e) => setEditComment(e.target.value)}
                            as="textarea"
                            rows={3}
                            placeholder="What do you want to eidt about?"
                        />
                        <div className="edit-action">
                            <div className="action-button" onClick={handleSaveEditedReply}>Save</div>
                            <div className="action-button" onClick={handleCancelReply}>Cancel</div>
                        </div>
                    </div>:<div className="comment">{comment}</div>}
                <div className="reply-status">
                    <div className="like-icon" onClick={handleLiked}>
                        <FontAwesome name="heart" style={{color: isLiked?"red":"gray"}}/>
                    </div>
                    <div className="like-count">{likedCount}</div>
                </div>
            </div>
            <ConfirmModal
                show={confirmShow}
                onClose={() => {
                  if (!isDeleting)
                    setConfirmShow(false)
                }}
                onOk={() => handleDelete()}
                title="Delete Reply"
                msg="Sure you want to delete your reply?"
                actionText="Yes, delete"
                isWorking={isDeleting}
            />
            <Modal
                show={showSelectImageModal} 
                onHide={hideImageModal} 
                animation={true} 
                size='lg'
                keyboard
            >
                <Modal.Header closeButton/>
                <Modal.Body>
                    <ImageSelector
                        profile={profile}
                        onSaveImages={handleSaveImages}
                        onClose={hideImageModal}
                        currentImages={editImages}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Reply;